<template>
  <a-drawer
    placement="right"
    :closable="true"
    :visible="drawerVisibility"
    wrapClassName="topic-discussion-drawer"
    width="49.2vw"
    :title="discussionDrawerTitle"
    @close="$emit('close-drawer')"
  >
    <div class="topic-discussion-drawer-container">
      <div class="topic-discussion-drawer-container__header">
        <div
          v-if="isPDBPage"
          class="topic-discussion-drawer-container__header--tabs"
        >
          <button
            v-if="getInterestGroup.length > 1"
            class="tab"
            :class="{ 'active-tab': activeTab === 'public' }"
            @click="changeTab('public')"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              src="@/assets/icons/world.svg"
              alt="icon"
            >
              <path
                d="M8.99996 17.3334C7.86107 17.3334 6.78468 17.1146 5.77079 16.6771C4.7569 16.2396 3.87149 15.6424 3.11454 14.8854C2.3576 14.1285 1.76038 13.2431 1.32288 12.2292C0.885376 11.2153 0.666626 10.1389 0.666626 9.00002C0.666626 7.84724 0.885376 6.76738 1.32288 5.76044C1.76038 4.75349 2.3576 3.87155 3.11454 3.1146C3.87149 2.35766 4.7569 1.76044 5.77079 1.32294C6.78468 0.885437 7.86107 0.666687 8.99996 0.666687C10.1527 0.666687 11.2326 0.885437 12.2395 1.32294C13.2465 1.76044 14.1284 2.35766 14.8854 3.1146C15.6423 3.87155 16.2395 4.75349 16.677 5.76044C17.1145 6.76738 17.3333 7.84724 17.3333 9.00002C17.3333 10.1389 17.1145 11.2153 16.677 12.2292C16.2395 13.2431 15.6423 14.1285 14.8854 14.8854C14.1284 15.6424 13.2465 16.2396 12.2395 16.6771C11.2326 17.1146 10.1527 17.3334 8.99996 17.3334ZM8.99996 15.625C9.36107 15.125 9.67357 14.6042 9.93746 14.0625C10.2013 13.5209 10.4166 12.9445 10.5833 12.3334H7.41663C7.58329 12.9445 7.79857 13.5209 8.06246 14.0625C8.32635 14.6042 8.63885 15.125 8.99996 15.625ZM6.83329 15.2917C6.58329 14.8334 6.36454 14.3577 6.17704 13.8646C5.98954 13.3715 5.83329 12.8611 5.70829 12.3334H3.24996C3.65274 13.0278 4.15621 13.632 4.76038 14.1459C5.36454 14.6597 6.05551 15.0417 6.83329 15.2917ZM11.1666 15.2917C11.9444 15.0417 12.6354 14.6597 13.2395 14.1459C13.8437 13.632 14.3472 13.0278 14.75 12.3334H12.2916C12.1666 12.8611 12.0104 13.3715 11.8229 13.8646C11.6354 14.3577 11.4166 14.8334 11.1666 15.2917ZM2.54163 10.6667H5.37496C5.33329 10.3889 5.30204 10.1146 5.28121 9.84377C5.26038 9.57294 5.24996 9.29169 5.24996 9.00002C5.24996 8.70835 5.26038 8.4271 5.28121 8.15627C5.30204 7.88544 5.33329 7.61113 5.37496 7.33335H2.54163C2.47218 7.61113 2.4201 7.88544 2.38538 8.15627C2.35065 8.4271 2.33329 8.70835 2.33329 9.00002C2.33329 9.29169 2.35065 9.57294 2.38538 9.84377C2.4201 10.1146 2.47218 10.3889 2.54163 10.6667ZM7.04163 10.6667H10.9583C11 10.3889 11.0312 10.1146 11.052 9.84377C11.0729 9.57294 11.0833 9.29169 11.0833 9.00002C11.0833 8.70835 11.0729 8.4271 11.052 8.15627C11.0312 7.88544 11 7.61113 10.9583 7.33335H7.04163C6.99996 7.61113 6.96871 7.88544 6.94788 8.15627C6.92704 8.4271 6.91663 8.70835 6.91663 9.00002C6.91663 9.29169 6.92704 9.57294 6.94788 9.84377C6.96871 10.1146 6.99996 10.3889 7.04163 10.6667ZM12.625 10.6667H15.4583C15.5277 10.3889 15.5798 10.1146 15.6145 9.84377C15.6493 9.57294 15.6666 9.29169 15.6666 9.00002C15.6666 8.70835 15.6493 8.4271 15.6145 8.15627C15.5798 7.88544 15.5277 7.61113 15.4583 7.33335H12.625C12.6666 7.61113 12.6979 7.88544 12.7187 8.15627C12.7395 8.4271 12.75 8.70835 12.75 9.00002C12.75 9.29169 12.7395 9.57294 12.7187 9.84377C12.6979 10.1146 12.6666 10.3889 12.625 10.6667ZM12.2916 5.66669H14.75C14.3472 4.97224 13.8437 4.36808 13.2395 3.85419C12.6354 3.3403 11.9444 2.95835 11.1666 2.70835C11.4166 3.16669 11.6354 3.64238 11.8229 4.13544C12.0104 4.62849 12.1666 5.13891 12.2916 5.66669ZM7.41663 5.66669H10.5833C10.4166 5.05558 10.2013 4.47919 9.93746 3.93752C9.67357 3.39585 9.36107 2.87502 8.99996 2.37502C8.63885 2.87502 8.32635 3.39585 8.06246 3.93752C7.79857 4.47919 7.58329 5.05558 7.41663 5.66669ZM3.24996 5.66669H5.70829C5.83329 5.13891 5.98954 4.62849 6.17704 4.13544C6.36454 3.64238 6.58329 3.16669 6.83329 2.70835C6.05551 2.95835 5.36454 3.3403 4.76038 3.85419C4.15621 4.36808 3.65274 4.97224 3.24996 5.66669Z"
              />
            </svg>
            <p>Public Discussions</p>
          </button>
          <button
            class="tab"
            :class="{ 'active-tab': activeTab === 'private' }"
            @click="changeTab('private')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="48"
              viewBox="0 96 960 960"
              width="48"
            >
              <path
                d="M220 976q-24.75 0-42.375-17.625T160 916V482q0-24.75 17.625-42.375T220 422h70v-96q0-78.85 55.606-134.425Q401.212 136 480.106 136T614.5 191.575Q670 247.15 670 326v96h70q24.75 0 42.375 17.625T800 482v434q0 24.75-17.625 42.375T740 976H220Zm260.168-200Q512 776 534.5 753.969T557 701q0-30-22.668-54.5t-54.5-24.5Q448 622 425.5 646.5t-22.5 55q0 30.5 22.668 52.5t54.5 22ZM350 422h260v-96q0-54.167-37.882-92.083-37.883-37.917-92-37.917Q426 196 388 233.917 350 271.833 350 326v96Z"
              />
            </svg>
            <p>Private Discussions</p>
          </button>
        </div>
        <div class="topic-discussion-drawer-container__header--right">
          <date-select-dropdown
            @filterDate="filterCommentsWithDate"
          ></date-select-dropdown>
          <button
            class="btn"
            @click="visibleInvitationCategory()"
            v-if="
              isPDBPage &&
                (activeTab === 'public' ||
                  (activeTab === 'private' &&
                    (filteredInterest && filteredInterest.permission === 'admin')))
            "
          >
            <img src="@/assets/icons/add-user.png" />
          </button>
        </div>
      </div>
      <div
        v-if="!isArticleView"
        class="topic-discussion-drawer-container__sub-header"
      >
        <div class="topic-discussion-drawer-container__sub-header--left">
          <div
            v-if="filteredStudents.length > 0 && filteredStudents.length === 1"
            class="images"
          >
            <img
              :src="
                filteredStudents[0].profile_picture ||
                  filteredStudents[0].profilePicture
              "
            />
          </div>
          <div
            v-else-if="
              filteredStudents.length > 0 && filteredStudents.length === 2
            "
            class="images"
          >
            <img
              :src="
                filteredStudents[0].profile_picture ||
                  filteredStudents[0].profilePicture
              "
            />
            <img
              :src="
                filteredStudents[1].profile_picture ||
                  filteredStudents[1].profilePicture
              "
            />
          </div>
          <div
            v-else-if="
              filteredStudents.length > 0 && filteredStudents.length > 2
            "
            class="images"
          >
            <img
              :src="
                filteredStudents[0].profile_picture ||
                  filteredStudents[0].profilePicture
              "
            />
            <img
              :src="
                filteredStudents[1].profile_picture ||
                  filteredStudents[1].profilePicture
              "
            />
            <img
              :src="
                filteredStudents[filteredStudents.length - 1].profile_picture ||
                  filteredStudents[filteredStudents.length - 1].profilePicture
              "
            />
          </div>

          <h2
            v-if="filteredStudents.length > 0 && filteredStudents.length === 1"
            class="name"
          >
            You
          </h2>
          <h2
            v-else-if="
              filteredStudents.length > 0 && filteredStudents.length === 2
            "
            class="name"
          >
            You and
            {{ filteredStudents[0].full_name || filteredStudents[0].name }}
          </h2>
          <h2
            v-else-if="
              filteredStudents.length > 0 && filteredStudents.length > 2
            "
            class="name"
          >
            You and {{ filteredStudents.length - 1 }} others
          </h2>
        </div>
        <div class="topic-discussion-drawer-container__sub-header--right">
          <button class="btn" v-if="!isPDBPage">
            <img src="@/assets/icons/download-icon.png" />
          </button>
          <student-select-dropdown
            v-if="activeTab != 'public'"
            :group="activeTab"
            :showFolderUsers="!isPDBPage"
            @filterStudentDiscussion="filterStudentDiscussion"
          ></student-select-dropdown>
        </div>
      </div>
      <div
        class="topic-discussion-drawer-container__discussion-container"
        v-if="discoverTopicDiscussionLoader"
      >
        <a-skeleton
          v-for="discussionCard in 5"
          :key="discussionCard"
          active
          :avatar="{ shape: 'square' }"
          :title="{ width: '30%' }"
          :paragraph="{ rows: 2, width: ['100%', '50%'] }"
          class="topic-discussion-drawer-container__discussion-container--discussion-card-skeleton"
        />
      </div>
      <div
        class="topic-discussion-drawer-container__discussion-container"
        v-if="!discoverTopicDiscussionLoader && discussionComments.length <= 0"
      >
        <h5 class="message">Content not found</h5>
      </div>
      <div
        class="topic-discussion-drawer-container__discussion-container"
        :class="{ 'article-view': isArticleView }"
        v-else-if="
          !discoverTopicDiscussionLoader && discussionComments.length > 0
        "
      >
        <div v-for="comment in discussionComments" :key="comment.id">
          <discussion-card
            :discussionComment="comment"
            :closeEditLoader="closeEditLoader"
            :deleteLoader="deleteLoader"
            @deleteComment="deleteComment"
            @updateComment="updateComment"
            @replyComment="showReplyBox"
            @likeComment="likeComment"
            @deleteCommentLike="deleteCommentLike"
          ></discussion-card>
          <div
            class="topic-discussion-drawer-container__discussion-container--reply-comment"
          >
            <discussion-card
              v-for="childComment in comment.child"
              :key="childComment.id"
              :discussionComment="childComment"
              :closeEditLoader="closeEditLoader"
              :deleteLoader="deleteLoader"
              @deleteComment="deleteComment"
              @updateComment="updateComment"
              @likeComment="likeComment"
              @deleteCommentLike="deleteCommentLike"
              :showReplyCommentButton="false"
            ></discussion-card>
            <div v-if="comment.isReplying" class="input">
              <img :src="loggedInUserProfile?.profile_picture" />
              <textarea
                name=""
                id="commentTextarea"
                cols="30"
                rows="1"
                placeholder="Add comment..."
                v-model="repliedComment"
              ></textarea>
              <div class="buttons">
                <a-button
                  :loading="replyLoading"
                  class="btn"
                  :class="{ disabled: isRepliedCommentDisabled }"
                  :disabled="isRepliedCommentDisabled"
                  @click="replyComment(comment)"
                >
                  <i class="icon icon-send"></i>
                </a-button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-show="activeTab === 'public'">
          <discussion-card :link="false"></discussion-card>
          <discussion-card :link="true"></discussion-card>
        </div>
        <div v-show="activeTab === 'private'">
          <discussion-card :link="true"></discussion-card>
          <discussion-card :link="false"></discussion-card>
          <discussion-card :link="true"></discussion-card>
          <discussion-card :link="false"></discussion-card>
        </div> -->
      </div>
      <div class="topic-discussion-drawer-container__footer">
        <div class="topic-discussion-drawer-container__footer--comment">
          <img :src="loggedInUserProfile?.profile_picture" />
          <textarea
            name=""
            id="commentTextarea"
            cols="30"
            rows="1"
            placeholder="Add comment..."
            v-model="comment"
          ></textarea>
          <div class="buttons">
            <a-button
              :loading="loading"
              class="btn"
              :class="{ disabled: isDisabled }"
              :disabled="isDisabled"
              @click="createComment()"
            >
              <i class="icon icon-send"></i>
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </a-drawer>

  <invite-category
    :visible="inviteCategoryModal"
    @handle-close="inviteCategoryModal = false"
    :categoryOptions="categoryOptions"
    @show-success-modal="showInvitationSubmit"
    :categoryId="interestId"
    :selectedCategory="inviteCategory"
    :interestGroupId="interestGroupId"
  ></invite-category>
</template>
<script>
import DateSelectDropdown from "./DateSelectDropdown.vue";
import DiscussionCard from "./DiscussionCard.vue";
import StudentSelectDropdown from "./StudentSelectDropdown.vue";
import inviteCategory from "../PdbComponents/InviteToDiscussionModal.vue";
import { mapGetters } from "vuex";
export default {
  emits: ["close-drawer"],
  data() {
    return {
      comment: "",
      activeTab: "public",
      publicLinks: [],
      privateLinks: [],
      inviteCategoryModal: false,
      isPrivate: this.isPrivateTopic,
      showMessageModal: false,
      message: {},
      inviteCategory: [],
      loading: false,
      replyLoading: false,
      closeEditLoader: false,
      showCommentDeleteModal: false,
      deleteLoader: false,
      repliedComment: "",
      filterOptions: {},
    };
  },
  props: {
    drawerVisibility: Boolean,
    interestGroupId: String,
    isPDBPage: Boolean,
    isArticleView: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isPrivateTopic: {
      immediate: true,
      handler() {
        if (this.isPrivateTopic) {
          this.audienceImage = "/img/private-icon.7305aeec.svg";
        } else if (!this.isPrivateTopic) {
          this.audienceImage = "/img/public-icon.6218e119.svg";
        }
      },
    },
    interestGroupId: {
      handler(val) {
        this.topicGroupId = val;
      },
    },
    getInterestGroup: {
      immediate: true,
      handler(val) {
        if (val.length > 1) {
          this.activeTab = "public";
        } else {
          this.activeTab = "private";
        }
      },
    },
  },

  computed: {
    ...mapGetters({
      privateTopicDiscussionUsers: "discussion/privateTopicDiscussionUsers",
      publicTopicDiscussionUsers: "discussion/publicTopicDiscussionUsers",
      discoverTopicDiscussionLoader: "discussion/discoverTopicDiscussionLoader",
      selectedDiscussionArticleId: "discussion/selectedDiscussionArticleId",
      permission: "profile/topicsCategories",
    }),
    filteredInterest() {
      // Assuming you are using Vue Router to access the route params
      const routeId = this.$route.params.id;

      // Find the object in the array where the interest id matches the route id
      return this.permission.find((item) => item.interest.id === routeId);
    },
    isDisabled() {
      return this.comment.trim() === "";
    },
    isRepliedCommentDisabled() {
      return this.repliedComment.trim() === "";
    },
    categoryOptions() {
      return this.$store.getters["profile/getUserInterests"];
    },
    interestGroupAudience() {
      var value = "";
      this.$store.getters["article/getInterestGroup"].forEach((element) => {
        value = element.is_private;
      });
      return value;
    },
    getInterestGroup() {
      const resp = this.$store.getters["article/getInterestGroup"];
      resp.forEach((element) => {
        if (element.is_private) {
          this.privateTopicGroupId = element.id;
          // this.fetchComments('private')
        } else if (!element.is_private) {
          // this.fetchComments('public')
          this.publicTopicGroupId = element.id;
        }
      });
      return resp;
    },
    discussionComments() {
      if (this.isPDBPage)
        return this.activeTab === "public"
          ? this.$store.getters["discussion/getPublicDiscussionComments"]
          : this.$store.getters["discussion/getPrivateDiscussionComments"];
      else if (this.isArticleView)
        return this.$store.getters["discover/getDiscoverArticleComments"];
      else
        return this.$store.getters["folders/getFolderComments"]
          ? this.$store.getters["folders/getFolderComments"]
          : [];
    },
    interestId() {
      return this.$route.params.id;
    },
    loggedInUserProfile() {
      return this.$store.getters["profile/userInformation"].profile;
    },
    filteredStudents() {
      let users = [];
      if (this.isPDBPage) {
        users =
          this.activeTab === "public"
            ? [...this.publicTopicDiscussionUsers]
            : [...this.privateTopicDiscussionUsers];
      } else {
        users = this.$store.getters["folders/getUsersWithFolderAccess"];
      }
      return users;
    },
    folderId() {
      if (!this.isPDBPage) return this.$route.params.id;
      else return null;
    },
    discussionDrawerTitle() {
      if (this.isPDBPage) return "Topic Discussion";
      else if (this.isArticleView) return "Article Comments";
      else return "Organisation Discussion";
    },
  },
  components: {
    DateSelectDropdown,
    DiscussionCard,
    StudentSelectDropdown,
    inviteCategory,
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab;
    },
    visibleInvitationCategory() {
      this.inviteCategoryModal = true;
      let obj = {
        id: this.interestId,
        name: this.interestName,
      };
      this.inviteCategory.push(obj);
    },
    showInvitationSubmit() {
      this.showMessageModal = true;
      this.message = {
        title: "Invitation Sent Successfully",
        type: "success",
      };
    },
    async createComment() {
      try {
        this.loading = true;
        if (this.isPDBPage) {
          const payload = {
            comment: this.comment,
            parent: null,
            interest_id: this.interestId,
            interest_group_id:
              this.activeTab === "private"
                ? this.privateTopicGroupId
                : this.activeTab === "public"
                ? this.publicTopicGroupId
                : this.topicGroupId,
          };
          const response = await this.$store.dispatch(
            "discussion/createDiscussionComment",
            payload
          );
          if (response.status === 201) {
            this.activeTab === "private"
              ? this.$store.dispatch("discussion/updateCommentList", {
                  group: "PRIVATE_DISCUSSION",
                  comment: response.data,
                })
              : this.$store.dispatch("discussion/updateCommentList", {
                  group: "PUBLIC_DISCUSSION",
                  comment: response.data,
                });
            this.comment = "";
            this.fetchComments(response.data);
            this.loading = false;
            //   const payload = {
            //   interest_group_id: this.activeTab === 'private' ? this.privateTopicGroupId : this.publicTopicGroupId ,
            //   interest_id: this.interestId,
            //   filterOptions: null
            // }
            // const fetchDiscussion = this.activeTab === 'private' ? "discussion/setPrivateDiscussionComments" : "discussion/setPublicDiscussionComments"
            // await this.$store.dispatch(
            //   fetchDiscussion,
            //   payload
            // );
            //   this.comment = "";
          }
        } else if (this.isArticleView) {
          try {
            const payload = {
              comment: this.comment,
              parent: null,
              article_id: this.selectedDiscussionArticleId,
            };
            const response = await this.$store.dispatch(
              "discover/discoverArticleComment",
              payload
            );
            if (response.status === 201) {
              this.comment = "";
              this.loading = false;
              this.fetchComments();
            }
          } catch (err) {
            console.log(err);
            this.loading = false;
          }
        } else {
          const form = new FormData();
          form.append("comment", this.comment);
          const folderPayload = {
            comment: form,
            folderId: this.folderId,
          };
          const response = await this.$store.dispatch(
            "folders/createFolderComment",
            folderPayload
          );
          if (response.status === 201) {
            this.comment = "";
            this.discussionComments.push(response.data);
            this.fetchComments(null, this.folderId);
            this.loading = false;
          }
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async deleteComment(comment) {
      try {
        this.deleteLoader = true;
        if (this.isPDBPage) {
          const payload = {
            discussion_id: comment.id,
            interest_id: comment.interest,
            interest_group_id:
              this.activeTab === "private"
                ? this.privateTopicGroupId
                : this.publicTopicGroupId,
            parent: comment.parent,
            group: this.activeTab.toUpperCase(),
          };
          const response = await this.$store.dispatch(
            "discussion/deleteDiscussionComments",
            payload
          );
          if (response.status === 204) {
            await this.fetchComments(comment);
            this.deleteLoader = false;
            this.$showToast({message:'Comment removed successfully!', type:'success'})
          }
        } else if (this.isArticleView) {
          try {
            const payload = {
              comment_id: comment.id,
              article_id: comment.article_data,
            };
            const response = await this.$store.dispatch(
              "discover/deleteDiscoverArticleComment",
              payload
            );
            if (response.status === 204) {
              await this.fetchComments();
              this.deleteLoader = false;
            }
          } catch (err) {
            console.log(err);
            this.deleteLoader = false;
          }
        } else {
          const payload = {
            commentId: comment.id,
            folderId: comment.folder,
          };
          const response = await this.$store.dispatch(
            "folders/deleteFolderComments",
            payload
          );
          if (response.status === 204) {
            await this.fetchComments(comment);
            this.deleteLoader = false;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async updateComment(comment) {
      try {
        this.closeEditLoader = false;
        if (this.isPDBPage) {
          const payload = {
            comment: comment.editedComment,
            discussion_id: comment.id,
            interest_id: comment.interest,
            interest_group_id:
              this.activeTab === "private"
                ? this.privateTopicGroupId
                : this.publicTopicGroupId,
            group: this.activeTab.toUpperCase(),
          };
          const response = await this.$store.dispatch(
            "discussion/updateDiscussionCommentst",
            payload
          );
          if (response.status === 200) {
            this.fetchComments(comment);
            this.closeEditLoader = true;
          }
        } else if (this.isArticleView) {
          const payload = {
            comment: comment.editedComment,
            comment_id: comment.id,
            article_id: comment.article_data,
          };
          const response = await this.$store.dispatch(
            "discover/updateDiscoverArticleComment",
            payload
          );
          if (response.status === 200) {
            this.fetchComments();
            this.closeEditLoader = true;
          }
        } else {
          const form = new FormData();
          form.append("comment", comment.editedComment);
          const payload = {
            comment: form,
            commentId: comment.id,
            folderId: comment.folder,
          };
          const response = await this.$store.dispatch(
            "folders/updateFolderCommentst",
            payload
          );
          if (response.status === 200) {
            this.fetchComments(comment);
            this.closeEditLoader = true;
          }
        }
      } catch (err) {
        console.log(err);
        this.closeEditLoader = true;
      }
    },
    async replyComment(parentComment) {
      try {
        if (this.isPDBPage) {
          this.replyLoading = true;
          const payload = {
            comment: this.repliedComment,
            parent: parentComment.id,
            interest_id: parentComment.interest,
            interest_group_id:
              this.activeTab === "private"
                ? this.privateTopicGroupId
                : this.publicTopicGroupId,
          };
          const response = await this.$store.dispatch(
            "discussion/createDiscussionComment",
            payload
          );
          if (response.status === 201) {
            await this.fetchComments(parentComment);
            this.repliedComment = "";
            this.replyLoading = false;
          }
        } else if (this.isArticleView) {
          try {
            this.replyLoading = true;
            const payload = {
              comment: this.repliedComment,
              parent: parentComment.id,
              article_id: parentComment.article_data,
            };
            const response = await this.$store.dispatch(
              "discover/discoverArticleComment",
              payload
            );
            if (response.status === 201) {
              this.repliedComment = "";
              this.replyLoading = false;
              this.fetchComments();
            }
          } catch (err) {
            console.log(err);
            this.replyLoading = false;
          }
        } else {
          const form = new FormData();
          form.append("comment", this.repliedComment);
          form.append("parent", parentComment.id);
          const payload = {
            comment: form,
            folderId: parentComment.folder,
          };
          const response = await this.$store.dispatch(
            "folders/createFolderComment",
            payload
          );
          if (response.status === 201) {
            await this.fetchComments(parentComment);
            this.repliedComment = "";
            this.replyLoading = false;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    showReplyBox(parentComment) {
      this.discussionComments.forEach((comment) => {
        if (comment.id === parentComment.id) {
          if (comment.isReplying) {
            comment.isReplying = false;
          } else {
            comment.isReplying = true;
          }
        } else {
          comment.isReplying = false;
        }
      });
    },
    async fetchComments(
      comment = null,
      interest_id = null,
      filterOptions = null
    ) {
      if (this.isPDBPage) {
        const payload = {
          interest_group_id:
            this.activeTab === "private"
              ? this.privateTopicGroupId
              : this.publicTopicGroupId,
          interest_id: comment ? comment.interest : interest_id,
          group: this.activeTab.toUpperCase(),
          filterOptions: filterOptions ? filterOptions : null,
        };
        await this.$store.dispatch("discussion/setDiscussionComments", payload);
      } else if (this.isArticleView) {
        const payload = {
          article_id: interest_id
            ? interest_id
            : this.selectedDiscussionArticleId,
          filterOptions: filterOptions ? filterOptions : null,
        };
        await this.$store.dispatch(
          "discover/fetchDiscoverArticleComments",
          payload
        );
      } else {
        const payload = {
          folderId: comment ? comment.folder : interest_id,
          filterOptions: filterOptions ? filterOptions : null,
        };
        await this.$store.dispatch("folders/fetchFolderComments", payload);
      }
    },
    async filterCommentsWithDate({ startDate, endDate }) {
      let interestOrFolderOrArticleId = null;
      if (this.isPDBPage) interestOrFolderOrArticleId = this.interestId;
      else if (this.isArticleView)
        interestOrFolderOrArticleId = this.selectedDiscussionArticleId;
      else interestOrFolderOrArticleId = this.folderId;

      const filterOptions = {
        startDate: startDate,
        endDate: endDate,
      };
      this.$store.dispatch("discussion/toggleDiscoverTopicCommentLoader");
      await this.fetchComments(
        null,
        interestOrFolderOrArticleId,
        filterOptions
      );
      this.$store.dispatch("discussion/toggleDiscoverTopicCommentLoader");
    },
    async filterStudentDiscussion(student) {
      const interestOrFolderId = this.isPDBPage
        ? this.interestId
        : this.folderId;
      if (student) {
        this.selectedStudent = student.id;
        const filterOptions = {
          user: student.id,
          group: this.activeTab.toUpperCase(),
          interestGroupId:
            this.activeTab === "private"
              ? this.privateTopicGroupId
              : this.publicTopicGroupId,
        };
        this.$store.dispatch("discussion/toggleDiscoverTopicCommentLoader");
        await this.fetchComments(null, interestOrFolderId, filterOptions);
        this.$store.dispatch("discussion/toggleDiscoverTopicCommentLoader");
      } else {
        this.$store.dispatch("discussion/toggleDiscoverTopicCommentLoader");
        await this.fetchComments(null, interestOrFolderId);
        this.$store.dispatch("discussion/toggleDiscoverTopicCommentLoader");
      }
    },
    formatDate(date) {
      let year = date.getFullYear();
      let day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
      let month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
      return `${year}-${month}-${day}`;
    },
    async likeComment({ discussionComment, action }) {
      if (this.isPDBPage) {
        const payload = {
          interestGroupId:
            this.activeTab === "private"
              ? this.privateTopicGroupId
              : this.publicTopicGroupId,
          interestId: discussionComment.interest,
          commentId: discussionComment.id,
          action,
        };
        await this.$store.dispatch("discussion/likeComment", payload);
        this.discussionComments.forEach((comment) => {
          if (comment.id === discussionComment.id) {
            const counterAction = action.action === "like" ? "dislike" : "like";
            comment[`current_user_${action.action}`] = true;
            comment[`current_user_${counterAction}`] = null;
          }
        });
        this.fetchComments(discussionComment);
      } else if (this.isArticleView) {
        const payload = {
          action: action,
          comment_id: discussionComment.id,
          article_id: discussionComment.article_data,
        };
        await this.$store.dispatch("discover/likeComment", payload);
        this.discussionComments.forEach((comment) => {
          if (comment.id === discussionComment.id) {
            const counterAction = action.action === "like" ? "dislike" : "like";
            comment[`current_user_${action.action}`] = true;
            comment[`current_user_${counterAction}`] = null;
          }
        });
        this.fetchComments();
      } else {
        const payload = {
          commentId: discussionComment.id,
          action,
        };
        await this.$store.dispatch("folders/likeFolderComment", payload);
        this.fetchComments(discussionComment);
      }
    },
    async deleteCommentLike(discussionComment) {
      if (this.isPDBPage) {
        const payload = {
          interestGroupId:
            this.activeTab === "private"
              ? this.privateTopicGroupId
              : this.publicTopicGroupId,
          interestId: discussionComment.interest,
          commentId: discussionComment.id,
        };
        await this.$store.dispatch("discussion/deleteLikeDislike", payload);
        this.fetchComments(discussionComment);
      } else if (this.isArticleView) {
        const payload = {
          article_id: discussionComment.article_data,
          comment_id: discussionComment.id,
        };
        await this.$store.dispatch("discover/deleteLikeDislike", payload);
        this.discussionComments.forEach((comment) => {
          comment[`current_user_like`] = null;
          comment[`current_user_dislike`] = null;
        });
        this.fetchComments();
      } else {
        await this.$store.dispatch(
          "folders/deleteLikeDislike",
          discussionComment.id
        );
        this.fetchComments(discussionComment);
      }
    },
  },
};
</script>

<style lang="scss">
.topic-discussion-drawer {
  .ant-drawer-content-wrapper {
    @include respond(laptop-small) {
      width: 70vw !important;
    }
    @include respond(tab-port) {
      width: 90vw !important;
    }
    .ant-drawer-content {
      .ant-drawer-wrapper-body {
        overflow: hidden;
        .ant-drawer-header {
          padding: 2.4rem 2.9rem 1.1rem !important;
          border: none;
          .ant-drawer-title {
            font-size: 2.4rem;
            font-family: $font-primary-bold;
            opacity: 1;
            color: $color-black;
            line-height: 3.2rem;
          }
          .ant-drawer-close {
            width: 2rem;
            height: 2rem;
            line-height: normal;
            right: 2.5rem;
            top: 3rem;
            color: $color-black;
            opacity: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            .anticon {
              svg {
                fill: $color-black;
              }
            }
          }
        }
        .ant-drawer-body {
          padding: 0;
          height: calc(100% - 6.7rem);
          .topic-discussion-drawer-container {
            position: relative;
            height: 100%;
            &__header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0 2.9rem;
              &--tabs {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 1.6rem;
                overflow-x: auto;
                .tab {
                  padding: 1.2rem 1.7rem;
                  display: flex;
                  align-items: center;
                  width: max-content;
                  justify-content: center;
                  border: none;
                  outline: none;
                  background-color: $color-light-grey-3;
                  border-radius: 100px !important;
                  cursor: pointer;
                  margin: 0.5rem 0;
                  span {
                    display: block;
                    width: max-content;
                  }
                  p {
                    font-size: 1.4rem;
                    font-family: $font-primary;
                    line-height: 1.6rem;
                    color: $color-black;
                    margin-bottom: 0;
                    width: max-content;
                  }
                  svg {
                    width: 1.6rem;
                    height: auto;
                    fill: $color-primary;
                    margin-right: 1.2rem;
                  }
                }
                .active-tab {
                  background-color: $color-primary;
                  svg {
                    fill: $color-white;
                  }
                  p {
                    color: $color-white;
                  }
                }
                &::-webkit-scrollbar {
                  height: 0.4rem;
                }

                &::-webkit-scrollbar-track {
                  background-color: $color-white;
                  border-radius: 0.8rem;
                  height: 0.4rem;
                }

                &::-webkit-scrollbar-thumb {
                  background-color: $color-primary;
                  border-radius: 0.8rem;
                }

                @include respond(phone-x-small) {
                  &::-webkit-scrollbar {
                    display: none;
                  }
                }
              }
              &--right {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 1rem;
                margin-left: auto;
                .btn {
                  border: none;
                  outline: none;
                  width: 3rem;
                  height: 3rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 100% !important;
                  background-color: #d6dcf0;
                  cursor: pointer;
                  img {
                    width: 1.2rem;
                  }
                }
                .topic-discussion-date-select-dropdown {
                  padding-left: 0;
                }
              }
            }
            &__sub-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 1.1rem 2.9rem;
              margin-top: 2.1rem;
              border-top: 1px solid #0000001a;
              border-bottom: 1px solid #0000001a;
              &--left {
                display: flex;
                align-items: center;
                .images {
                  display: flex;
                  align-items: center;
                  padding-left: 1.8rem;
                  img {
                    width: 3.8rem;
                    object-fit: cover;
                    height: 3.8rem;
                    border: 1px solid #cccccc;
                    border-radius: 100%;
                    margin-left: -1.8rem;
                  }
                }
                .name {
                  font-size: 1.8rem;
                  font-family: $font-primary;
                  color: $color-black;
                  line-height: 2.4rem;
                  margin-bottom: 0;
                  margin-left: 1rem;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  line-clamp: 1;
                  -webkit-box-orient: vertical;
                }
              }
              &--right {
                display: flex;
                align-items: center;
                gap: 2rem;
                .btn {
                  border: none;
                  outline: none;
                  width: 3.8rem;
                  height: 3.8rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 100% !important;
                  background-color: #e1e8ff;
                  cursor: pointer;
                  &__user-icon {
                    width: 1.6rem !important;
                  }
                  img {
                    width: 1.8rem;
                  }
                }
              }
            }
            &__discussion-container {
              padding: 0 1.4rem 0;
              height: calc(100vh - 38.5rem);
              overflow-y: auto;
              margin: 2.4rem 1.5rem 0;
              &--discussion-card-skeleton {
                margin-bottom: 1.5rem;
                .ant-skeleton-header {
                  height: 4rem;
                  width: 4rem;
                  border-radius: 100%;
                  padding: 0;
                  .ant-skeleton-avatar {
                    height: 4rem;
                    width: 4rem;
                    border-radius: 100%;
                  }
                }
                .ant-skeleton-content {
                  padding-left: 1.5rem;
                  .ant-skeleton-title {
                    margin: 0.5rem 0 1.5rem;
                    height: 2rem;
                  }
                  .ant-skeleton-paragraph {
                    margin: 0;
                    li {
                      margin: 0 0 1rem;
                    }
                  }
                }
              }
              &--reply-comment {
                padding-left: 3rem;
                position: relative;
                .input {
                  background-color: #f5f5f5;
                  border: 1px solid #00000033;
                  padding: 0 1.3rem;
                  border-radius: 1rem;
                  display: flex;
                  align-items: center;
                  img {
                    width: 3rem;
                    height: 3rem;
                    border-radius: 100%;
                    object-fit: fill;
                    background-color: rgb(216, 216, 216);
                  }
                  textarea {
                    padding: 1.4rem 1.5rem;
                    margin: 1rem 0;
                    border: none;
                    font-size: 1.4rem;
                    font-family: $font-primary;
                    box-shadow: none;
                    outline: none;
                    line-height: 1.8rem;
                    color: $color-black;
                    background-color: transparent;
                    resize: none;
                    width: 100%;
                    &::placeholder {
                      color: #868686;
                    }
                    &::-webkit-scrollbar {
                      display: none;
                    }
                  }
                  .buttons {
                    display: flex;
                    align-items: center;
                    .disabled {
                      opacity: 0.5;
                      cursor: not-allowed;
                    }
                    .ant-btn {
                      width: 7rem;
                      background-color: $color-primary;
                      border: none;
                      outline: none;
                      height: 4rem;
                      font-size: 1.4rem;
                      font-family: $font-primary-medium !important;
                      color: $color-white;
                      border-radius: 100px !important;
                      padding: 0 !important;
                      span {
                        line-height: normal;
                      }
                      .anticon {
                        .anticon-spin {
                          font-size: 1.8rem;
                          color: $color-primary;
                        }
                      }
                      &:hover,
                      &:focus {
                        background-color: $color-primary;
                        color: $color-white;
                      }
                      .icon {
                        font-size: 2rem;
                        display: block;
                        color: $color-white;
                      }
                    }
                  }
                }
              }
              .message {
                font-size: 1.6rem;
                font-family: $font-primary;
                margin-bottom: 0;
                margin-top: 2rem;
                text-align: center;
              }
              &::-webkit-scrollbar {
                width: 0.4rem;
                height: 0.4rem;
              }

              &::-webkit-scrollbar-track {
                background-color: transparent;
                border-radius: 0.8rem;
              }

              &::-webkit-scrollbar-thumb {
                background-color: $color-primary;
                border-radius: 0.8rem;
                width: 0.4rem;
                height: 0.4rem;
              }
            }
            &__footer {
              position: absolute;
              bottom: 0;
              width: 100%;
              border-top: 1px solid #00000033;
              padding: 3rem 2.9rem;
              background-color: $color-white;
              &--comment {
                background-color: #eeeeee;
                padding: 0 1.3rem;
                border-radius: 1rem;
                display: flex;
                align-items: center;
                img {
                  width: 3.8rem;
                  height: 3.8rem;
                  border-radius: 100%;
                  object-fit: fill;
                }
                textarea {
                  padding: 1.4rem 1.5rem;
                  margin: 1rem 0;
                  border: none;
                  font-size: 1.4rem;
                  font-family: $font-primary;
                  box-shadow: none;
                  outline: none;
                  line-height: 1.8rem;
                  color: $color-black;
                  background-color: transparent;
                  resize: none;
                  width: 100%;
                  &::placeholder {
                    color: #868686;
                  }
                  &::-webkit-scrollbar {
                    display: none;
                  }
                }
                .buttons {
                  display: flex;
                  align-items: center;

                  & .icon-send {
                    font-size: large;
                  }

                  // .btn {
                  //   width: 9.6rem;
                  //   display: flex;
                  //   align-items: center;
                  //   justify-content: center;
                  //   font-size: 1.4rem;
                  //   color: $color-white;
                  //   background-color: $color-primary;
                  //   font-family: $font-primary-medium;
                  //   outline: none;
                  //   border: none;

                  //   height: 4rem;
                  //   margin-left: 1.6rem;
                  //   cursor: pointer;
                  // }
                  .disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                  }
                  .ant-btn {
                    width: 7rem;
                    background-color: $color-primary;
                    border: none;
                    outline: none;
                    height: 4rem;
                    font-size: 1.4rem;
                    font-family: $font-primary-medium !important;
                    color: $color-white;
                    border-radius: 100px !important;
                    padding: 0 !important;
                    span {
                      line-height: normal;
                    }
                    .anticon {
                      .anticon-spin {
                        font-size: 1.8rem;
                        color: $color-primary;
                      }
                    }
                    &:hover,
                    &:focus {
                      background-color: $color-primary;
                      color: $color-white;
                    }
                    .icon {
                      font-size: 2rem;
                      display: block;
                      color: $color-white;
                    }
                  }
                }
              }
            }
          }
          .article-view {
            height: calc(100vh - 25.5rem);
          }
        }
      }
    }
  }
}
</style>
